/* RESPONSIBLE TEAM: team-reporting */

export type SchemaMode = 'legacy' | 'tabular';

// Tabular rendering is the default. Add `?schema=legacy` to URL to use legacy rendering.
export function getSchemaMode(): SchemaMode {
  if (typeof window === 'undefined') {
    return 'tabular';
  }

  const searchParams = new URLSearchParams(window.location.search);
  return searchParams.get('schema') === 'legacy' ? 'legacy' : 'tabular';
}
